import { useEffect, useState } from 'react'
import { applyTheme, readTheme, saveTheme, type Theme } from '../session/theme'

const STANDEN: { waarde: Theme; label: string }[] = [
  { waarde: 'system', label: 'Systeem' },
  { waarde: 'light', label: 'Licht' },
  { waarde: 'dark', label: 'Donker' },
]

/**
 * De keuze licht/donker, zoals hij in de menu's staat.
 *
 * Begint op `Systeem`. Zolang die stand geldt volgt de app de telefoon, ook als
 * die halverwege de avond omslaat — precies wat je wil op een feest dat om zes
 * uur begint. Kiest iemand zelf, dan blijft dat staan.
 */
export function ThemeChoice() {
  const [theme, setTheme] = useState<Theme>(readTheme)

  // Het attribuut staat er al voor React begon (zie index.html); dit houdt de
  // kleur van de adresbalk bij als het systeem omslaat terwijl we op `Systeem`
  // staan.
  useEffect(() => {
    if (theme !== 'system') {
      return
    }

    const media = window.matchMedia('(prefers-color-scheme: dark)')
    const bij = () => applyTheme('system')

    media.addEventListener('change', bij)

    return () => media.removeEventListener('change', bij)
  }, [theme])

  function kies(waarde: Theme) {
    setTheme(waarde)
    saveTheme(waarde)
  }

  return (
    <div className="px-3.5 pt-2.5 pb-1.5">
      <p className="text-ink-faint text-[11px] font-semibold tracking-[0.09em] uppercase">
        Weergave
      </p>

      <div
        role="radiogroup"
        aria-label="Weergave"
        className="bg-surface-sunk border-line-menu mt-2 flex gap-0.5 rounded-lg border p-0.75"
      >
        {STANDEN.map((stand) => {
          const actief = stand.waarde === theme

          return (
            <button
              key={stand.waarde}
              type="button"
              role="radio"
              aria-checked={actief}
              onClick={() => kies(stand.waarde)}
              className={
                'flex-1 cursor-pointer rounded-md py-1.75 text-[12.5px] font-medium ' +
                (actief
                  ? 'bg-surface text-ink shadow-raised'
                  : 'text-ink-soft hover:text-ink-muted')
              }
            >
              {stand.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
